'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Rules.StrategyAccordion', dependencies).directive('rmStrategyAccordion', require('./directives/StrategyAccordionDirective'));